export async function initServiceWorker() {
  const hostname = window.location.hostname
  const protocol = window.location.protocol
  let url = `${protocol}//${hostname}/service-worker.js`

  if (hostname === 'localhost') {
    const port = window.location.port
    url = `${protocol}//${hostname}:${port}/service-worker.js`
  }

  let swRegistration = await navigator.serviceWorker.register(url, {
    scope: '/',
  })
  let pushManager = swRegistration.pushManager

  let permissionState = await pushManager.permissionState({
    userVisibleOnly: true,
  })
  switch (permissionState) {
    case 'prompt':
      console.log('prompt needed')
      break
    case 'granted':
      const info = await pushManager.getSubscription()
      console.log('subscription info', info)
      break
    case 'denied':
      console.log('denied')
  }
}
